import React from 'react';

export const HALF_WIDTH = { upper: 23, lower: 22.5 };

export const NAME = { upper: 'Qoziq tish', lower: 'Qoziq tish' };

/*
 * Upper canine: the single pointed cusp sits slightly mesial to the centre, the
 * mesial cusp slope is shorter than the distal one, and the root is the longest
 * and stoutest in the arch.
 */
const UPPER_OUTLINE = `M 33 46
    C 29.6 57.4 27.4 66.6 27 74
    C 26.9 77 27.6 79.4 29.4 81
    C 34.4 86.4 40 92.4 44.8 95.8
    Q 47.4 97.6 50 95.6
    C 55 91.6 62 85.4 67.2 79.6
    C 69.8 77 71.4 73.4 71.6 68.4
    C 72 59.4 70 50.4 67 46
    C 66.2 39.4 65.4 29 62.8 19.4
    C 61 12.6 58.6 6.8 55.8 5.2
    C 53.8 4 50.6 4.4 48.6 6.2
    C 45.6 9 42.8 20.4 39.6 31.4
    C 37 40 34.8 43.4 33 46 Z`;

const UPPER_CERVICAL = 'M 33 46 C 39.5 40.2 60.5 40.2 67 46';

const UPPER_DETAILS = [
    /* Labial ridge running from the cusp tip towards the cervical third. */
    'M 48.8 94.4 C 47.8 84 47 70 46.6 58',
    /* Depressions flanking the ridge, following the two cusp slopes. */
    'M 36.4 72 C 38.6 79 41.6 86 44.4 92.4',
    'M 62.8 70.4 C 61 76.4 57.4 83 53.6 89.4',
];

/*
 * Lower canine: narrower and less bulky than the upper one, with a lower cusp
 * tip and a long root that carries a longitudinal groove.
 */
const LOWER_OUTLINE = `M 35 42
    C 32.6 32 30.8 23 30.4 18
    C 30.2 15.6 31 13.4 32.8 12.4
    C 37.4 9.4 42.6 5.6 45.4 3.4
    Q 47.8 1.6 50.2 3.6
    C 54 7 59.4 11.6 63.4 14.8
    C 65.2 16.2 66.3 18.8 66.2 22.4
    C 66 29 65.6 36.2 65 42
    C 66.8 52 67.2 64 65.6 74.6
    C 64.4 83 62 89.6 58.8 92.4
    Q 54.8 95.8 50.4 94.4
    C 47.2 93.4 44.8 89.4 43.2 83
    C 41 75 39.6 63 38.6 53
    C 38.2 49 37.4 45.4 35 42 Z`;

const LOWER_CERVICAL = 'M 35 42 C 41.5 46.4 58.5 46.4 65 42';

const LOWER_DETAILS = [
    'M 48.2 5.2 C 48.8 16 49.2 28 49.2 38',
    'M 36 16.4 C 38 22 41 28.4 44.2 34',
    'M 61.4 18.8 C 59.4 24 56.4 29.4 53.4 34',
    'M 51.5 52 C 52 64 52 76 51.4 88',
];

export default function Canine({ jaw }) {
    const isUpper = jaw === 'upper';

    return (
        <>
            <path d={isUpper ? UPPER_OUTLINE : LOWER_OUTLINE} className="dental-tooth__body" />
            <path d={isUpper ? UPPER_CERVICAL : LOWER_CERVICAL} className="dental-tooth__line" />
            {(isUpper ? UPPER_DETAILS : LOWER_DETAILS).map((d) => (
                <path key={d} d={d} className="dental-tooth__detail" />
            ))}
        </>
    );
}
